import { useEffect, Component } from "react";
import { Toaster } from "sonner";
import "@/App.css";
import { initLenis } from "@/lib/scroll";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { LiveChart } from "@/components/LiveChart";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Tokenomics } from "@/components/Tokenomics";
import { HowToBuy } from "@/components/HowToBuy";
import { Roadmap } from "@/components/Roadmap";
import { Community } from "@/components/Community";
import { OfficialLinks } from "@/components/OfficialLinks";
import { AiCowChat } from "@/components/AiCowChat";
import { Footer } from "@/components/Footer";
import { SpaceIntro } from "@/components/SpaceIntro";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#08080F] text-[#F0FDF4]">
          <p className="font-display text-xl">Something broke in the pasture. Refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const App = () => {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <ErrorBoundary>
      <LanguageProvider>
        <SpaceIntro />
        <div className="min-h-screen bg-[#08080F] text-[#F0FDF4]">
          <div className="grain-overlay" />
          <Navbar />
          <main>
            <Hero />
            <LiveChart />
            <Marquee />
            <About />
            <Tokenomics />
            <HowToBuy />
            <Roadmap />
            <Community />
            <OfficialLinks />
          </main>
          <Footer />
          <AiCowChat />
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#14141E",
                border: "1px solid rgba(153,69,255,0.4)",
                color: "#F0FDF4",
              },
            }}
          />
        </div>
      </LanguageProvider>
    </ErrorBoundary>
  );
};

export default App;
